import { IGlobalState } from '@/reducer';
import IToken from './IToken';
import dayjs from 'dayjs';
import { doLogout } from './sagas';

export function decodedTokenSelector(_state: IGlobalState): IToken {
    const decodedToken: IToken = localStorage.getItem('decodedToken') && JSON.parse(localStorage.getItem('decodedToken'));

    if (decodedToken && dayjs(decodedToken.exp * 1000) < dayjs()) {
        doLogout();

        return null;
    }

    return decodedToken;
}